import auth from "@/api/auth";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("authToken") || null,
    loading: false,
    user: JSON.parse(localStorage.getItem("user")),
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    getUser: (state) => state.user,
  },
  actions: {
    login({ commit }, data) {
      commit("setLoading", true);
      return auth
        .login(data)
        .then((response) => {
          commit("setToken", response.data.token);
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    resetPassword({ commit }, data) {
      commit("setLoading", true);
      return auth
        .resetPassword(data)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    askResetPassword({ commit }, email) {
      commit("setLoading", true);
      return auth
        .askresetPassword(email)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("authToken", token);
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    clearAuthData(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("cust_stryker_one");
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
};
